import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Summary from "./Summary";

const Header = ({ summaryDate, handleDateChange, attendance }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-[#fff] shadow-cs mt-[24px] p-[20px] rounded-md">
        <div className="mb-[10px] review-summary">
          <div className="flex attendece-date">
            <div className="flex justify-between w-full items-center">
              <input
                className="border-[#dbdbdb] bg-white p-[6px] border rounded-[6px] font-medium text-[14px] focus:outline-none"
                type="date"
                onClick={(e) => e.target.showPicker()}
                value={summaryDate}
                onChange={(e) => handleDateChange(e)}
              />
              <button onClick={() => {
                navigate("/approve-attendance", { state: { attendance: attendance, summaryDate: summaryDate } });
              }} className="second-btn items-center flex">Review</button>
            </div>
          </div>
          <Summary attendance={attendance} />
        </div>
      </div>
      <div className="flex gap-[10px] bg-[#ffff] shadow-cs mt-[24px] p-[20px] rounded-md over-new">
        <Link
          to="/worktime"
          className="pr-2 border-r font-medium text-[#27004a] text-[14px] hover:text-[#8e54c2] whitespace-nowrap transition"
        >
          Daily Work Entry
        </Link>
        <Link
          to="/reviewfine"
          className="pr-2 border-r font-medium text-[#27004a] text-[14px] hover:text-[#8e54c2] whitespace-nowrap transition"
        >
          Fine
        </Link>
        <Link
          to="/overtime"
          className="pr-2 font-medium text-[#27004a] text-[14px] hover:text-[#8e54c2] whitespace-nowrap transition"
        >
          Overtime
        </Link>
      </div>
    </>
  );
};

export default Header;
